import { useMutation } from '@tanstack/react-query';
import { findAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
/** Shared mutationKey so consumers can detect in-flight upserts via `useIsMutating`. */
export const UPSERT_AGENT_WITH_EMAIL_KEY = ['upsertAgentWithEmail'];
/**
 * Account-level upsert for both the email-only invite flow and CSV import.
 * Each invocation upserts a single agent; consumers loop for batch flows.
 *
 * Does NOT invalidate `listAgents` on success — invalidate once at the batch
 * level (see InviteByEmailDialog / ImportCsvDialog) to avoid N refetches.
 */
export function useUpsertAgentWithEmail() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    return useMutation({
        mutationKey: [...UPSERT_AGENT_WITH_EMAIL_KEY],
        mutationFn: async ({ email, name, whatsAppE164, adminNotes }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findAction(user, 'upsertAgentWithEmail');
            if (!action)
                throw new Error('upsertAgentWithEmail action unavailable');
            const body = { email };
            if (name && name.length > 0)
                body.name = name;
            if (whatsAppE164 && whatsAppE164.length > 0)
                body.whatsAppE164 = whatsAppE164;
            if (adminNotes && adminNotes.length > 0)
                body.adminNotes = adminNotes;
            const response = await invokeAction(action, user.token, { body });
            if (!response.ok)
                throw new Error(`upsertAgentWithEmail returned ${response.status}`);
        },
    });
}
